import { createAsyncThunk } from '@reduxjs/toolkit';
import type { User } from '@/types';
import api from '@/api/client';
import { setUser, setAuthenticated, setIsAdmin } from '../slices/authSlice';

export const login = createAsyncThunk<
  boolean,
  { login: string; password: string },
  { rejectValue: string }
>('auth/login', async (creds, { dispatch, rejectWithValue }) => {
  try {
    await api.post('/users/login', creds);
    dispatch(setAuthenticated(true));
    await dispatch(getAuthenticatedInfo());
    return true;
  } catch (err: unknown) {
    const message = err instanceof Error ? err.message : 'Login failed';
    return rejectWithValue(message);
  }
});

export const checkAuthentication = createAsyncThunk(
  'auth/check',
  async (_, { dispatch }) => {
    try {
      await api.post('/users/check-authentication');
      // Backend returns 200 with empty body when cookie is valid; restore session
      dispatch(setAuthenticated(true));
      await dispatch(getAuthenticatedInfo());
    } catch {
      // not authenticated (401 or no cookie)
    }
  }
);

export const getAuthenticatedInfo = createAsyncThunk(
  'auth/current',
  async (_, { dispatch }) => {
    try {
      const { data } = await api.get<{ data: User }>('/users/current');
      dispatch(setUser(data.data));
      dispatch(setIsAdmin(!!data.data.is_admin));
    } catch {
      // ignore
    }
  }
);
